
import * as skrollTop from 'skrolltop';
import { isMobileRes } from '../../../utils/Utils';

class TermsOfService{
    constructor(){
        this.main = document.getElementById('terms_of_service');

        this._contentIndex = this.main.querySelector('.content_index');
        this._dataContent = [...this.main.querySelectorAll('.data_content')];
        this._isScrolling = false;
        
        Array.from(this.main.querySelectorAll('.index a')).forEach((btn)=>{
            btn.addEventListener('click', this._onClickIndexBtn.bind(this));
        });

        setTimeout(() => {
            document.documentElement.scrollTop = 0;
        }, 0);
        
        setTimeout(() => {
            if (window.location.hash !== '' && document.getElementById(window.location.hash.substring(1))) {
                this._goTo(window.location.hash.substring(1));
            }

            window.addEventListener('scroll', this._onScroll.bind(this));
        }, 150);

    }

    _onClickIndexBtn(e){
        e.preventDefault();

        this._goTo(e.target.getAttribute('data-content-id'));
    }

    _goTo(contentId){
        let scrollY = document.getElementById(contentId).offsetTop;

        scrollY = isMobileRes() ? scrollY - 80 : scrollY - 100;

        this._isScrolling = true;

        skrollTop.scrollTo({
            element: window,
            to: scrollY,
            duration: 600,
            callback: () => {
                this._isScrolling = false;
            }
        });
    }

    _onScroll() {
        if(!this._isScrolling) {
            let scrollY = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
            scrollY = isMobileRes() ? scrollY + 80 : scrollY + 100;
            
            if ((scrollY < this._contentIndex.offsetTop + this._contentIndex.clientHeight)) {
                if (window.location.hash !== '') {
                    history.replaceState(null, null, ' ');
                }

                return;
            }

            // Get active content
            let activeContent = this._dataContent.slice().reduce((a, b) => {
                const aDiff = scrollY - a.offsetTop;
                const bDiff = scrollY - b.offsetTop;
   
                return Math.abs(bDiff) < Math.abs(aDiff) ? b : a;
            });

            if(window.location.hash !== `#${activeContent.id}`) {
                history.pushState({}, "", `#${activeContent.id}`);
            }
        }
    }
}

export default TermsOfService;